// extracted by mini-css-extract-plugin
export default {"CollapseBox":"CollapseBox_CollapseBox__09ga+","CollapseBox__Title":"CollapseBox_CollapseBox__Title__pRier","CollapseBox__TitleName":"CollapseBox_CollapseBox__TitleName__szsIv"};